import {Container, Nav, Navbar, Offcanvas} from "react-bootstrap";
import {Link} from "react-router-dom";
import React from "react";

import {useHelpSection} from "../hooks/useHelpSection";
import {AppSettings} from "../settings";
import "../css/navbar.css";

const TheCellMapNavbar = () => {
  const helpSection = useHelpSection();

  return <Navbar id="main-navbar" bg="dark" data-bs-theme="dark" fixed="top" className="py-0" expand="sm"
                 collapseOnSelect>
    <Container fluid>
      <Navbar.Brand className="py-0">
        <div className="d-flex align-items-center gap-1">
          <a href="//thecellmap.org" title="Landing page">TheCellMap</a>
          <span>–</span>
          <a href={AppSettings.LOCAL_URL_PREFIX} title="Human CellMap">Human</a>
        </div>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav"/>
      <Navbar.Offcanvas placement="end" id="offcanvasNavbar" bg="dark" data-bs-theme="dark">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            TheCellMap Menu
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="ms-auto">
            <Nav.Link href="https://boonelab.ccbr.utoronto.ca/supplement/billmann2026/" target="_blank">
              Download Dataset
            </Nav.Link>
            <Nav.Link as={Link} to={`/help#${helpSection}`}>Help</Nav.Link>
            <Nav.Link as={Link} to="/about">About</Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Navbar.Offcanvas>
    </Container>
  </Navbar>;
};

export default TheCellMapNavbar;
